// import * as env from "../src/common/env";

// const url = window.location.origin;
// const online = !url.includes("localhost");
// const test = url.includes("ldl-test") || !online;

const authConfiguration = {

    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    //   identityPoolId: "eu-central-1:8d474819-94a2-4e4b-9a2b-11020243e459",
    // REQUIRED - Amazon Cognito Region
    region: "eu-central-1",
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: "eu-central-1_jDaRTOhaW",
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: "37ka14rrf5a4si2t7g9vpv4qcp",
    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false,
    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    cookieStorage: {

        // REQUIRED - Cookie domain (only required if cookieStorage is provided)
        // domain: online ? (test ? ".ldl-test.eu" : ".liberidalavoro.it") : ".localhost",
        domain: "localhost",
        // OPTIONAL - Cookie path
        path: "/",
        // OPTIONAL - Cookie expiration in days
        // expires: 365,
        // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
        sameSite: "lax",
        // OPTIONAL - Cookie secure flag
        // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
        secure: true,
    },
    // OPTIONAL - customized storage object
    //   storage: localStorage,
    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: "USER_PASSWORD_AUTH",
    // OPTIONAL - Hosted UI configuration
    oauth: {
        
        domain: "ldl-test-pool.auth.eu-central-1.amazoncognito.com",
        scope: ["email", "profile", "openid", "aws.cognito.signin.user.admin"],
        redirectSignIn: "http://localhost:3000/app/reservedArea",
        // redirectSignOut: env.baseBackendUrl + "/app/login",
        redirectSignOut: "http://localhost:3000/app",
        responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
};

export default authConfiguration;
